import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const HasPool = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.66602 12.4998C3.05768 11.8748 4.44102 11.2498 5.83268 10.9748V4.1665C5.83268 3.50346 6.09607 2.86758 6.56491 2.39874C7.03376 1.9299 7.66964 1.6665 8.33268 1.6665C9.42435 1.6665 10.3493 2.35817 10.691 3.33317H8.33268C8.11167 3.33317 7.89971 3.42097 7.74343 3.57725C7.58715 3.73353 7.49935 3.94549 7.49935 4.1665V4.99984H11.666V4.1665C11.666 3.50346 11.9294 2.86758 12.3982 2.39874C12.8671 1.9299 13.503 1.6665 14.166 1.6665C15.2577 1.6665 16.1827 2.35817 16.5243 3.33317H14.166C13.945 3.33317 13.733 3.42097 13.5768 3.57725C13.4205 3.73353 13.3327 3.94549 13.3327 4.1665V12.4498C14.9993 12.1832 16.666 10.8332 18.3327 10.8332V12.4998C16.4827 12.4998 14.6327 14.1665 12.7743 14.1665C10.9243 14.1665 9.07435 12.4998 7.22435 12.4998C5.36601 12.4998 3.51602 13.3332 1.66602 14.1665V12.4998ZM11.666 6.6665H7.49935V8.33317H11.666V6.6665ZM11.666 9.99984H7.49935V10.8332C8.89101 10.9665 10.2743 11.9248 11.666 12.3248V9.99984ZM1.66602 15.8332C3.51602 14.9998 5.36601 14.1665 7.22435 14.1665C9.07435 14.1665 10.9243 15.8332 12.7743 15.8332C14.6327 15.8332 16.4827 14.1665 18.3327 14.1665V15.8332C16.4827 15.8332 14.6327 17.4998 12.7743 17.4998C10.9243 17.4998 9.07435 15.8332 7.22435 15.8332C5.36601 15.8332 3.51602 16.6665 1.66602 17.4998V15.8332Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default HasPool;
